/**
 * El catálogo de módulos y el contrato de `GET /yo` — T-21.
 *
 * Vive aquí y no en la API porque **el panel lo necesita tanto como el
 * servidor**: es quien decide qué secciones muestra y qué fragmentos pide. Una
 * segunda copia en el navegador sería la forma más rápida de que la pantalla y
 * el 402 dijeran cosas distintas.
 *
 * Estuvo en la API desde T-17, con una nota que decía «vuelve en T-21, cuando la
 * API tome la dependencia de este paquete». Ya la tomó.
 *
 * Sigue siendo espejo de la tabla `modules`, y una prueba contrasta las dos
 * copias clave por clave y nombre por nombre.
 */
/** Los módulos vendibles por separado — ADR-009. */
export const MODULOS = {
    menu: 'Menú',
    loyalty: 'Lealtad',
};
/** El nombre que ve una persona. Identificadores en inglés, mensajes en español — §7. */
export const nombreDeModulo = (modulo) => MODULOS[modulo];
/**
 * Qué le da al dueño cada módulo, en una frase — `T-71`, 2026-09-28.
 *
 * ── Por qué en un mapa aparte y no dentro de `MODULOS` ────────────────────
 * `MODULOS` es **espejo de la tabla `modules`**, y `autorizacion.test.ts` lo
 * contrasta clave por clave y nombre por nombre contra ella. Meterle una
 * descripción convertiría ese espejo en otra cosa y rompería la prueba que
 * vigila que las dos copias no se separen. La descripción no está en la tabla y
 * no tiene por qué estarlo: no la usa ninguna regla, sólo la lee una persona.
 *
 * ── Por qué existe ────────────────────────────────────────────────────────
 * «Lealtad · Activo» no le dice a nadie si eso incluye la tarjeta del cliente o
 * sólo los sellos del mostrador. Es la única pantalla donde el dueño ve qué
 * paga, y hasta hoy le enseñaba dos palabras.
 *
 * Se escribe desde lo que él ve, no desde lo que construimos: «la carta que ven
 * tus clientes», no «el módulo de catálogo».
 */
export const QUE_DA_EL_MODULO = {
    menu: 'La carta que ven tus clientes al escanear el QR de la mesa.',
    loyalty: 'Los sellos, el premio y la tarjeta del cliente en el mostrador.',
};
/** La frase de un módulo. Ver `QUE_DA_EL_MODULO`. */
export const queDaElModulo = (modulo) => QUE_DA_EL_MODULO[modulo];
//# sourceMappingURL=modulos.js.map